{
  "widget": {
    "intakeIntro": "Customise the intake form and widget appearance for your venue's chat widget",
    "customizeFields": "Customise Fields",
    "customizeEventTypes": "Customise event types",
    "customizeTime": "Customise time",
    "customizeHoursBody": "Customise the hours for which users can inquire about.",
    "appearanceIntro": "Customise how your chat widget looks to guests.",
    "colors": {
      "heading": "Widget Colours",
      "intro": "Apply your brand colours to the widget. Learn more about <0>web accessibility</0>.",
      "formBackground": "Background Colour",
      "text": "Text Colour",
      "accent": "Accent Colour",
      "formButtons": "Button Colour",
      "accentNoun": "the accent colour",
      "buttonNoun": "the button colour",
      "hexAria": "{{label}} hex colour",
      "pickerAria": "{{label}} colour picker"
    },
    "a11y": {
      "intro": "Web Content Accessibility Guidelines (WCAG) 2 is developed through the <0>W3C process</0> in cooperation with individuals and organisations around the world, with a goal of providing a single shared standard for web content accessibility.",
      "colorContrast": "Colour Contrast",
      "checker": "Our colour contrast checker aligns with the WCAG 2.2 guidelines and ratios."
    },
    "gtmHelpCenter": "See our help centre for instructions (opens in a new tab)"
  },
  "survey": {
    "customizeWidget": "Customise My Widget",
    "canceling": "Cancelling...",
    "prioritizeQuestions": "Your agent will prioritise these questions during the conversation. Customise them so the agent collects the most relevant information for your venue."
  },
  "reservations": {
    "status": {
      "canceled": "Cancelled"
    },
    "holdCanceled": {
      "title": "Hold Cancelled",
      "body": "The reservation hold has been cancelled successfully."
    },
    "organizer": "Organizer",
    "cancelingHold": "Cancelling Hold...",
    "venueRequest": {
      "finalizingMenu": "Finalising menu selections or guest count"
    },
    "tasks": {
      "finalizeMenu": "Finalise Menu"
    },
    "expenses": {
      "fetchError": "Something went wrong when fetching the check",
      "fetchErrorBody": "Refresh this page or try again later."
    }
  },
  "accounts": {
    "inviteBody": "Dear {{inviteeFirstName}},\n\nI'm reaching out because we're rolling out a new programme designed specifically for our most valued partners. The programme will make discovering, booking, and paying for reservations at {{venueGroupName}} venues even easier while offering a range of exclusive benefits:\n\n- Early access to our most exclusive properties\n- Unlock corporate rates and rewards\n- Private line and corporate experiences\n- Custom menus and prices\n- 24/7 access and support\n- Centralised place for communication and receipts\n\nBest regards,\n{{inviterFirstName}}"
  },
  "onboarding": {
    "eventProgram": {
      "title": "Upload Event Programme Details",
      "label": "Event Programmes"
    },
    "analyzing": "Analysing contents..."
  },
  "overview": {
    "annualizedSpend": "Annualised Spend",
    "annualizedSpendTooltip": "<0>Annualised Spend</0> projects annualised processed spend for the selected venue(s), calculated from payments since the first transaction of the current year."
  },
  "helpCenter": "in the Ande Help Centre.",
  "shell": {
    "footer": {
      "smsProgram": "SMS Programme"
    }
  },
  "rewards": {
    "seeProgramDetails": "See Programme Details"
  },
  "auth": {
    "affiliateProgramSuccess": "You have successfully gained access to the affiliate programme. We're taking you to our inventory!"
  },
  "fees": {
    "salesTaxPlaceholder": "e.g. CA Sales Tax"
  },
  "analytics": {
    "paymentMethodsHelp": "wire, check, or direct card charge"
  }
}
